// UI strings for the kind of an own word, shown beside its "meidän" tag (docs/design/sanapaja/16b-loans-names-calendar.md
// §1): an own loanword or borrowed name (Lemma.loan) is tagged "laina" (components/Badges.tsx LoanTag). Finnish first;
// en has the same shape.
import { defineArea } from '../area';

export const ownKindsFi = {
  /** the tag of an own loanword or borrowed name, beside "meidän" */
  loan: 'laina',
};

export const ownKindsEn: typeof ownKindsFi = {
  loan: 'loan',
};

// Messages.ownKinds (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('ownKinds', ownKindsFi, ownKindsEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof ownKindsFi> {}
}
